import { render } from "./contactCTA.vue?vue&type=template&id=016112dc&scoped=true"
import script from "./contactCTA.vue?vue&type=script&lang=js"
export * from "./contactCTA.vue?vue&type=script&lang=js"

import "./contactCTA.vue?vue&type=style&index=0&id=016112dc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016112dc"]])

export default __exports__